import Joi from "joi";
import errorsResolver from "../schemeUtils";
import { cityTypes, streetTypes } from "../../helpers/data-constants";



const CITY_LENGTH = 100;
const REGION_LENGTH = 100;

const STREET_LENGTH = 100;
const HOUSE_LENGTH = 30;
const BUILDING_LENGTH = 30;
const APARTMENT_LENGTH = 30;
const POSTAL_CODE_LENGTH = 10;

const clientAddressScheme = Joi.object({
  index: Joi.any(),
  active: Joi.bool(),
  country: Joi.alternatives().conditional(Joi.object(), {
    then: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Страна обязательное поле`
        })),
      value: Joi.number()
        .error(errorsResolver({
          number: `Должно быть число`
        }))
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `Страна обязательное поле`,
        required: `Страна обязательное поле`
      })),
    otherwise: Joi.string()
      .required()
      .invalid(null)
      .error(errorsResolver({
        invalid: `Страна обязательное поле`,
        required: `Страна обязательное поле`
      }))
  }),
  region: Joi.alternatives().conditional(Joi.object(), {
    then: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Область обязательное поле`
        })),
      value: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Область обязательное поле`
        }))
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `Область обязательное поле`,
        required: `Область обязательное поле`
      })),
    otherwise: Joi.string()
      .allow('')
      .max(REGION_LENGTH)
      .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ\\- ]{1,${REGION_LENGTH}}$`))
      .error(errorsResolver({
        pattern: `Область содержит некорректные символы`,
        max: `Область должен быть меньше ${REGION_LENGTH} символов`
      }))
  }),
  cityType: Joi.alternatives().conditional(Joi.ref('city'), {
    is: Joi.object(),
    then: Joi.string()
      .required()
      .error(errorsResolver({
        required: `Тип населенного пункта обязательное поле`,
        values: `Тип населенного пункта обязательное поле`
      })),
    otherwise: Joi.string()
      .required()
      .valid(...cityTypes)
      .error(errorsResolver({
        required: `Тип населенного пункта обязательное поле`,
        values: `Тип населенного пункта обязательное поле`
      }))
  }),
  streetType: Joi.string()
    .allow('')
    .valid(...streetTypes)
    .error(errorsResolver({
      values: `Тип адреса обязательное поле`
    })),
  city: Joi.alternatives().conditional(Joi.object(), {
    then: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Населенный пункт обязательное поле`
        })),
      value: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Населенный пункт обязательное поле`
        })),
      name: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Населенный пункт обязательное поле`
        }))
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `Населенный пункт обязательное поле`,
        required: `Населенный пункт обязательное поле`
      })),
    otherwise: Joi.string()
      .required()
      .max(CITY_LENGTH)
      .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\(\\)\\.\\-,/№ ]{1,${CITY_LENGTH}}$`))
      .error(errorsResolver({
        required: `Населенный пункт обязательное поле`,
        pattern: `Населенный пункт содержит некорректные символы`,
        max: `Населенный пункт должен быть меньше ${CITY_LENGTH} символов`
      }))
  }),
  house: Joi.string()
    .required()
    .max(HOUSE_LENGTH)
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-:/]{1,${HOUSE_LENGTH}}$`))
    .error(errorsResolver({
      required: `Дом обязательное поле`,
      pattern: `Дом содержит некорректные символы`,
      max: `Дом должен быть меньше ${HOUSE_LENGTH} символов`
    })),
  street: Joi.alternatives().conditional(Joi.object(), {
    then: Joi.object({
      label: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Улица обязательное поле`
        })),
      value: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Улица обязательное поле`
        })),
      name: Joi.string()
        .required('')
        .error(errorsResolver({
          required: `Улица обязательное поле`
        }))
    })
      .invalid(null)
      .required()
      .error(errorsResolver({
        invalid: `Улица обязательное поле`,
        required: `Улица обязательное поле`
      })),
    otherwise: Joi.string()
      .required()
      .max(STREET_LENGTH)
      .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-()/., ]{1,${STREET_LENGTH}}$`))
      .error(errorsResolver({
        required: `Улица обязательное поле`,
        pattern: `Улица содержит некорректные символы`,
        max: `Улица должна быть меньше ${STREET_LENGTH} символов`
      }))
  }),
  building: Joi.string()
    .allow('')
    .max(BUILDING_LENGTH)
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-:/]{1,${BUILDING_LENGTH}}$`))
    .error(errorsResolver({
      pattern: `Корпус содержит некорректные символы`,
      max: `Корпус должен быть меньше ${BUILDING_LENGTH} символов`
    })),
  soato: Joi.string()
    .allow(''),
  apartment: Joi.string()
    .allow('')
    .max(APARTMENT_LENGTH)
    .pattern(new RegExp(`^[a-zA-Zа-яА-ЯёЁ0-9\\-:/]{1,${APARTMENT_LENGTH}}$`))
    .error(errorsResolver({
      pattern: `Квартира содержит некорректные символы`,
      max: `Квартира должна быть меньше ${APARTMENT_LENGTH} символов`
    })),
  postalCode: Joi.string()
    .allow('')
    .max(POSTAL_CODE_LENGTH)
    .pattern(new RegExp(`^[a-zA-Zа-яА-Я0-9\-]{1,${POSTAL_CODE_LENGTH}}$`))
    .optional()
    .error(errorsResolver({
      max: `Индекс должен быть меньше ${POSTAL_CODE_LENGTH} символов`,
      pattern: `Индекс содержит некорректные символы`,
    }))
});


export default clientAddressScheme;
